import { controls } from "./controls";

const home = {
  label: "Home",
  pageLabel: "Dashboard",
  starting: true,
  url: "home",
  pageType: "history",
  dashboard: [
    ...controls.displayText({ width: "col-sm-12", label: " ", tab: "filter" }),
    {
      widths: "col-sm-4",
      tab: "create",
      theme: "orotheme",
      title: "Banking Overview icon-selfWhatsApp",
      footer: "for yesterday (in Lakhs)",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list1",
          values: [
            {
              main: {
                desc: "Trial Balance", url: "trial_balance",
                payload: { branch_code: { type: "fixed", value: "0002" }, as_on_date: { type: "fixed", value: new Date() } }, value: "Needs Attention", color: "orange", size: 14
              }
            },
            { main: { desc: "Profit & Loss", value: "Rs. 18.97 Crore", color: "#8af07f" } },
            { main: { desc: "Comparative Balances", value: "Generator Fuel", url: "rp301", color: "#ff4646" } },
            { main: { desc: "Monthly Expenditure", value: "Rs. 12,32,383.43", url: "rp301", color: "orange" } },
            { main: { desc: "CD Ratio", value: "72.3", color: "#8af07f" } },
            { main: { desc: "Overdue", value: "Rs. 132.43 Crore", url: "rp301", color: "#ff4646" } },
            { main: { desc: "ATM Issuer Fees", url: "rp301", value: "Rs. 1,72,720 (#10161)", color: "#ff4646" } },
            { main: { desc: "Bank KYC Velocity", value: "783 / day", color: "#8af07f" } },
            { main: { desc: "Suspecious Transactions", url: "suspecioustxn", value: "Rs. 1,28,000", color: "orange" } },
            { main: { desc: "High Risk KYC Pending", value: "13", color: "#8af07f" } },
            { main: { desc: "Satisfaction Index", value: "icon-tick", color: "#8af07f" } },
            { main: { desc: "Accountability Index", value: "icon-tick", color: "#8af07f" } },
          ]
        }),
      ]
    },
    {
      widths: "col-sm-4",
      tab: "create",

      title: "Bank Status icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "in Lakhs",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Cash Balance", value: "Rs.18,23,22,000.29" } },
            { main: { desc: "Cash at ATMs", value: "Rs.1,49,28,000.00" } },
            { main: { desc: "Bank Balance", value: "Rs.96,18,24,442.29" } },
            { main: { desc: "Investments", value: "Rs.46,59,09,800.00" } },
            { main: { desc: "Total Loans", value: "Rs.9,59,98,96,200.00" } },
            { main: { desc: "Interest Receivable", value: "Rs.32,32,45,442.29" } },

            { main: { desc: "Total Deposits", value: "Rs.10,60,80,04,780.00" } },
            { main: { desc: "Borrowings", value: "Rs.1,50,00,00,000.00" } },
            { main: { desc: "Interest Payable", value: "Rs.32,45,442.29" } },

            { main: { desc: "CD Ratio", value: "79.28%" } },
            { main: { desc: "CRAR", value: "12.98%" } },

            { main: { desc: "Profit", value: "Rs.28,97,62,000.00" } },
            { main: { desc: "Net Worth", value: "Rs.5,78,47,42,532.87" } },
            { main: { desc: "Dormant Accounts", value: "1,24,229" } },
          ]
        }),
      ]
    },

    {
      widths: "col-sm-4",
      tab: "create",
      title: "Branch Status icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "in Lakhs",
      selfWhatsApp: "sendsummary",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Cash Balance", value: "Rs.16,23,223.42" } },
            { main: { desc: "Cash at ATMs", value: "Rs.5,32,000.00" } },
            { main: { desc: "Bank Balance", value: "Rs.0.0" } },
            { main: { desc: "Investments", value: "Rs.0.0" } },
            { main: { desc: "Total Loans", value: "Rs.14,33,67,590.00" } },
            { main: { desc: "Interest Receivable", value: "Rs.54,34,992.54" } },

            { main: { desc: "Total Deposits", value: "Rs.14,32,88,238.59" } },
            { main: { desc: "Borrowings (from HO)", value: "Rs.1,59,12,895.00" } },
            { main: { desc: "Interest Payable", value: "Rs.9,29,39,652.39" } },

            { main: { desc: "CD Ratio", value: "89.56%" } },
            { main: { desc: "CRAR", value: "11.14%" } },

            { main: { desc: "Profit", value: "Rs.29,32,348.21" } },
            { main: { desc: "Net Worth", value: "Rs.7,43,22,967.22" } },
            { main: { desc: "Dormant Accounts", value: "3,498" } },
          ]
        }),
      ]
    },



    {
      widths: "col-sm-4",
      tab: "create",
      title: "My Performance icon-selfWhatsApp",
      // style:{border:"none"},
      selfWhatsApp: "sendsummary",
      footer: "for the previous month",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Mobile Registrations", value: "212" } },
            { main: { desc: "SMS Service", value: "948" } },
            { main: { desc: "Recovery", value: "Rs.12,00,273.00" } },
            { main: { desc: "New Customer Deposits", value: "Rs.22,442.00" } },
            { main: { desc: "New Loans", value: "Rs.7,28,119.00" } },
            { main: { desc: "CKYC Compliance", value: "78" } },
            { main: { desc: "KYC renewals", value: "6" } },
            { main: { desc: "Deposit Renewals", value: "Rs.5,22,381.00" } },
          ]
        }),
      ]
    },
    {
      widths: "col-sm-4",
      tab: "create",
      theme: "targettheme",
      selfWhatsApp: "sendsummary",
      title: "My Targets icon-selfWhatsApp",
      // style:{border:"none"},
      footer: "for the current month",
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Mobile Registrations", value: "300" } },
            { main: { desc: "SMS Service", value: "200" } },
            { main: { desc: "Recovery", value: "Rs.3,00,000.00" } },
            { main: { desc: "New Deposits", value: "Rs.2,00,000.00" } },
            { main: { desc: "New Loans", value: "Rs.2,00,000.00" } },
            { main: { desc: "CKYC Compliance", value: "100" } },
            { main: { desc: "KYC renewals", value: "10" } },
          ]
        }),
      ]
    },
    {
      widths: "col-sm-4",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Support icon-selfWhatsApp",
      footer: "As on today.",
      style: { maxHeight: 303 },
      subComponents: [
        ...controls.kpiList({
          name: "kpi_list",
          values: [
            { main: { desc: "Total", value: "28" } },
            { main: { desc: "Open", value: "3" } },
            { main: { desc: "Closed", value: "25" } },
            { main: { desc: "L1 Open", value: "2" } },
            { main: { desc: "L2 Open", value: "1" } },
            { main: { desc: "L3 Open", value: "0" } },
            { main: { desc: "L4 Open", value: "0" } },
            { main: { desc: "Pendency", value: "1" } },
          ]
        })
      ]
    },




    // ...controls.iframe({ tab: "filter",url:"https://sync.shield.orobanking.com:8000/index-ibos.html", label: "",height:500 }),

    {
      widths: "col-sm-4",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Birthdays icon-selfWhatsApp",
      footer: "todays birthdays only",
      // style:{border:"none"},
      subComponents: [
        ...controls.FollowupList({
          name: "birthdays", values: [
            { main: { desc: "Chandrakant Patil" }, sub: { desc: { phone: "88399483292", offer: "Get senior citizen discount" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Rohan Choudhary" }, sub: { desc: { phone: "88399423292", offer: "Get senior citizen discount" }, action: { desc: 'Send SMS', api: "sendsms" } } },
          ]
        }),
      ]
    },
    {
      widths: "col-sm-4",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Pending KYC icon-selfWhatsApp",
      style: { paddingRight: 0 },
      subComponents: [
        ...controls.FollowupList({
          name: "pending_kyc", values: [
            { main: { desc: "Mayur Leve" }, sub: { desc: { phone: "8829938839", docs: "PAN" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Aniket Dharmadhikari" }, sub: { desc: { phone: "9844758746", docs: "PAN, AADHAAR" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Mangesh Fulari" }, sub: { desc: { phone: "9844777283", docs: "PAN, Mothers Name" }, action: { desc: 'Send SMS', api: "sendsms" } } }

          ]
        }),
      ]
    },
    {
      widths: "col-sm-4",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Potential Dormant Accounts icon-selfWhatsApp",
      footer: "in the next 2 months",
      style: { paddingRight: 0 },
      subComponents: [
        ...controls.FollowupList({
          name: "pending_kyc", values: [
            { main: { desc: "Sunil Lagoo" }, sub: { desc: { phone: "8830033709", ac: "003111200288398", since: "23 months" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Rohan Dhadde" }, sub: { desc: { phone: "8830033708", ac: "00311100288398", since: "23 months" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Anant Choudhari" }, sub: { desc: { phone: "9930033709", ac: "00311100288398", since: "22 months" }, action: { desc: 'Send SMS', api: "sendsms" } } },
          ]
        }),
      ]
    },

    {
      widths: "col-sm-4",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Installments overdue icon-selfWhatsApp",
      footer: "in coming 3 days",
      style: { maxHeight: 303 },
      subComponents: [
        ...controls.FollowupList({
          name: "probable_npa", values: [
            { main: { desc: "Vyankatesh Kurundkar" }, sub: { desc: { phone: "9830033709", ac: "00311100288398", currency: "Rs.12,989.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Mangesh Fulari" }, sub: { desc: { phone: "9844777283", ac: "00311100288238", currency: "Rs.8,280.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Amrutraj Gore" }, sub: { desc: { phone: "8380006707", ac: "00311100288239", currency: "Rs.5,080.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },

            { main: { desc: "Mahesh Jawale" }, sub: { desc: { phone: "8380006707", ac: "00311100288231", currency: "Rs.3,655.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },

            { main: { desc: "Ajit Kadam" }, sub: { desc: { phone: "7830033709", ac: "00311100288395", currency: "Rs.12,231.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Chandrakant Patil" }, sub: { desc: { phone: "8380006707", ac: "00311100288233", currency: "Rs.9,422.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },

            { main: { desc: "Vikram Pawar" }, sub: { desc: { phone: "6830033709", ac: "00311100288396", currency: "Rs.54,123.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
          ]
        }),
      ]
    },


    {
      widths: "col-sm-4",
      tab: "create",
      selfWhatsApp: "sendsummary",
      title: "Potential NPAs icon-selfWhatsApp",
      footer: "in 10-15 days from now.",
      style: { maxHeight: 303 },
      subComponents: [
        ...controls.FollowupList({
          name: "probable_npa", values: [
            { main: { desc: "Sunil Lagoo" }, sub: { desc: { phone: "8830033709", ac: "00311100288398", currency: "Rs.12,989.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Amrutraj Gore" }, sub: { desc: { phone: "8380006307", ac: "00311100288338", currency: "Rs.8,280.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Rohan Dhadde" }, sub: { desc: { phone: "8380006407", ac: "00311100288438", currency: "Rs.13,222.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },

            { main: { desc: "Mahesh Jawale" }, sub: { desc: { phone: "8380005707", ac: "00311100288538", currency: "Rs.4,553.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },

            { main: { desc: "Vishal Chaddha" }, sub: { desc: { phone: "8830036709", ac: "00311100288698", currency: "Rs.19,822.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
            { main: { desc: "Ajit Choudhary" }, sub: { desc: { phone: "8380076707", ac: "00311100288738", currency: "Rs.6,209" }, action: { desc: 'Send SMS', api: "sendsms" } } },

            { main: { desc: "Amar Singh" }, sub: { desc: { phone: "8830038709", ac: "00311100288898", currency: "Rs.3,002.00" }, action: { desc: 'Send SMS', api: "sendsms" } } },
          ]
        }),
      ]
    },


  ]
};

export default home;
